
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpEventType } from '@angular/common/http';
import * as TyreOfferModels from '../../models/tyre-offer/tyre-offer';
import { TyreOfferSearchModel } from '../../models/tyre-offer/tyre-offerSearch';
import { EnvironmentService } from '../../../app/services/environment.service';
import * as Models from '../../models/commonModels';

@Injectable({
  providedIn: 'root'
})

export class TyreOfferService {

constructor(private httpClient: HttpClient,
            private environmentService: EnvironmentService
            ) { }

  public geList(Search: TyreOfferSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();
    const options = { headers: httpHeaders };

    return this.httpClient.post<TyreOfferModels.TyreOfferListModel>(`${this.environmentService.getApiURL()}/tyre-offer/list`, Search, options);
  }

  public gePreviewList(Search: TyreOfferSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();
    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<TyreOfferModels.TyreOfferModel>>(`${this.environmentService.getApiURL()}/tyre-offer/preview-list`, Search, options);
  }

  public getReport(Search: TyreOfferSearchModel) {

    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

    const options = {headers: httpHeaders, responseType: 'blob' as 'json'};
    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/tyre-offer/report/filtered`, Search, options);
  }

  public refresh(TyreOffer: Models.Request<TyreOfferModels.TyreOfferModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreOfferModels.TyreOfferModel>>(`${this.environmentService.getApiURL()}/tyre-offer/refresh`, TyreOffer, options);
  }

  public set(TyreOffer: Models.Request<TyreOfferModels.TyreOfferModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };


    return this.httpClient.post<Models.Response<TyreOfferModels.TyreOfferModel>>(`${this.environmentService.getApiURL()}/tyre-offer/set/`, TyreOffer, options);
  }

  public assign(TyreOffer: Models.Request<TyreOfferModels.TyreOfferModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };


    return this.httpClient.post<Models.Response<TyreOfferModels.TyreOfferModel>>(`${this.environmentService.getApiURL()}/tyre-offer/assign`, TyreOffer, options);
  }
}
